module.exports = __webpack_public_path__ + "matkapital.008a8950c2f6b064612fc7c2a2e2be1b.jpg";